'use client'

import { QueryKey, UseQueryOptions, useQuery } from '@tanstack/react-query'

import { useClientApi } from '../useClientApi'

import type { TShipSearchItem } from '@/api/v1/resources/ship'

export type UseShipSearchResult = {
  data: TShipSearchItem[]
  isLoading: boolean
  error: Error | null
}

export type TOptionsQueryShipSearch = UseQueryOptions<
  TShipSearchItem[],
  unknown,
  TShipSearchItem[],
  QueryKey
>

export const shipSearchKey = (pattern?: string): QueryKey => [
  'v1',
  'ship',
  'search',
  { pattern: pattern?.trim() }
]

const useQueryShipSearch = (pattern: string, options?: TOptionsQueryShipSearch) => {
  const { api } = useClientApi()
  const trimmed = pattern?.trim()

  return useQuery({
    queryKey: shipSearchKey(trimmed),
    queryFn: async () => {
      return api.ship.search({ pattern: trimmed })
    },
    enabled: !!trimmed,
    staleTime: 30_000,
    ...options
  })
}

export default function useShipSearch(query: string): UseShipSearchResult {
  const queryHook = useQueryShipSearch(query)

  return {
    data: queryHook.data ?? [],
    isLoading: queryHook.isLoading,
    error: (queryHook.error as Error) ?? null
  }
}
